export default __webpack_public_path__ + "apply22c92ff.png";